export default __webpack_public_path__ + "static/media/belonging.18154b71.svg";